import {onDomContentLoaded} from "./common/lifecycle";
import {UserActivation} from "./common/userActivation";
import {Debounced} from "./common/debounced";

const unsupportedHeaderClasses = ['header_account', 'header_checkout'] as const;
const userActivation = new UserActivation();

onDomContentLoaded(() => {
    const header = querySupportedHeader();
    if (header === null) {
        return;
    }

    let rememberHeaderShown = ! document.body.classList.contains('headers-hidden'); // Used to avoid unnecessary class toggling.
    let rememberedScrollY = window.scrollY;

    const initialHeaderSlideInDelay = 500;

    /**
     * The regular debounce rate to prevent flickering of the
     * header when scrolling up and down too fast.
     */
    const debounceMillisDefault = 150;

    /**
     * The debounce rate after the window was resized. This should
     * be higher because resizing the window can trigger many
     * up and down scroll events. If the debounce rate was lower,
     * the header would flicker a lot.
     */
    const debounceMillisAfterResize = 500;

    let initialHeaderSlideInTimeout: number|null = setTimeout(() => {
        document.body.classList.remove('headers-hidden');
        rememberHeaderShown = true;
    }, initialHeaderSlideInDelay);

    window.addEventListener('resize', () => {
        toggleHeaderDebounced.setDelayMillis(debounceMillisAfterResize);
        toggleHeaderDebounced.setForceDebounceOnNextCall(true);
    });

    const toggleHeaderDebounced = new Debounced(() => {
        toggleHeaderDebounced.setDelayMillis(debounceMillisDefault);
        document.body.classList.toggle('headers-hidden', ! rememberHeaderShown);
    }, debounceMillisDefault);

    const invalidateHeaders = function() {
        if (! userActivation.hasBeenActive()) {
            // Header is only toggled after the user interacted with the page.
            rememberedScrollY = window.scrollY;
            return;
        }

        const previousScrollY = rememberedScrollY;
        const currentScrollY = window.scrollY;

        if (currentScrollY === previousScrollY) {
            return;
        }
        rememberedScrollY = currentScrollY;

        if (initialHeaderSlideInTimeout !== null) {
            clearTimeout(initialHeaderSlideInTimeout);
            initialHeaderSlideInTimeout = null;
        }

        const showHeaders = currentScrollY < previousScrollY;
        if (showHeaders === rememberHeaderShown) {
            return;
        }
        rememberHeaderShown = showHeaders;
        toggleHeaderDebounced.call();
    };

    document.addEventListener('scroll', invalidateHeaders, { passive: true });
});

function querySupportedHeader(): HTMLElement|null {
    const header = document.getElementById('header');
    if (header === null) {
        return null;
    }
    for (const unsupportedHeaderClass of unsupportedHeaderClasses) {
        if (header.classList.contains(unsupportedHeaderClass)) {
            return null;
        }
    }
    return header;
}
